import { render } from "./KomisionetKPK.vue?vue&type=template&id=279f0be9"
import script from "./KomisionetKPK.vue?vue&type=script&lang=js"
export * from "./KomisionetKPK.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__